import React from 'react';
import { css, cx } from '@emotion/css';

function Prices() {
  return (
    <div className={style.container} id="preise">
      <div className={style.title}>Preisliste*</div>
      <div className={style.priceContainer}>
        <div className={cx(style.gridElement, style.women)}>
          <div className={style.subtitle}>Frauen</div>
          <div className={style.priceTable}>
            <div className={style.articleColumn}>
              <div className={style.line}>&nbsp;</div>
              <div className={style.line}>Waschen, Schneiden, F&ouml;hnen</div>
              <div className={style.line}>Waschen, Schneiden</div>
              <div className={style.line}>Trocken schneiden</div>
              <div className={style.line}>Waschen, F&ouml;hnen</div>
              <div className={style.line}>Dauerwelle nach Aufwand</div>
            </div>
            <div className={style.priceColumn}>
              <div className={style.line}>Kurz</div>
              <div className={style.line}>42,-</div>
              <div className={style.line}>39,-</div>
              <div className={style.line}>33,-</div>
              <div className={style.line}>35,-</div>
              <div className={style.line}>ab 60,-</div>
            </div>
            <div className={style.priceColumn}>
              <div className={style.line}>Mittel</div>
              <div className={style.line}>46,-</div>
              <div className={style.line}>44,-</div>
              <div className={style.line}>36,-</div>
              <div className={style.line}>40,-</div>
              <div className={style.line}>&nbsp;</div>
            </div>
            <div className={style.priceColumn}>
              <div className={style.line}>Lang</div>
              <div className={style.line}>55,-</div>
              <div className={style.line}>53,-</div>
              <div className={style.line}>45,-</div>
              <div className={style.line}>45,-</div>
              <div className={style.line}>&nbsp;</div>
            </div>
          </div>
        </div>
        <div className={cx(style.gridElement, style.men)}>
          <div className={style.subtitle}>M&auml;nner</div>
          <div className={style.priceTable}>
            <div className={style.articleColumn}>
              <div className={style.line}>&nbsp;</div>
              <div className={style.line}>Waschen, Schneiden, F&ouml;hnen</div>
              <div className={style.line}>Trocken schneiden</div>
            </div>
            <div className={style.priceColumn}>
              <div className={style.line}>Kurz</div>
              <div className={style.line}>29,-</div>
              <div className={style.line}>25,-</div>
            </div>
            <div className={style.priceColumn}>
              <div className={style.line}>Mittel</div>
              <div className={style.line}>32,-</div>
              <div className={style.line}>28,-</div>
            </div>
            <div className={style.priceColumn}>
              <div className={style.line}>Lang</div>
              <div className={style.line}>34,-</div>
              <div className={style.line}>30,-</div>
            </div>
          </div>
        </div>
        <div className={cx(style.gridElement, style.children)}>
          <div className={style.subtitle}>Kinder bis 12 Jahre</div>
          <div className={style.priceTable}>
            <div className={style.articleColumn}>
              <div className={style.line}>&nbsp;</div>
              <div className={style.line}>Waschen, Schneiden, F&ouml;hnen</div>
              <div className={style.line}>Trocken schneiden</div>
            </div>
            <div className={style.priceColumn}>
              <div className={style.line}>Kurz</div>
              <div className={style.line}>25,-</div>
              <div className={style.line}>20,-</div>
            </div>
            <div className={style.priceColumn}>
              <div className={style.line}>Mittel</div>
              <div className={style.line}>27,-</div>
              <div className={style.line}>22,-</div>
            </div>
            <div className={style.priceColumn}>
              <div className={style.line}>Lang</div>
              <div className={style.line}>29,-</div>
              <div className={style.line}>26,-</div>
            </div>
          </div>
        </div>
        <div className={cx(style.gridElement, style.coloration)}>
          <div className={style.subtitle}>Coloration**</div>
          <div className={style.priceTable}>
            <div className={style.articleColumn}>
              <div className={style.line}>&nbsp;</div>
              <div className={style.line}>Coloration</div>
              <div className={style.line}>Str&auml;hnen nach Aufwand</div>
              <div className={style.line}>Balayage nach Aufwand</div>
              <div className={style.line}>Glossing</div>
              <div className={style.line}>Intensivpflege</div>
            </div>
            <div className={style.priceColumn}>
              <div className={style.line}>Kurz</div>
              <div className={style.line}>38,-</div>
              <div className={style.line}>45,-</div>
              <div className={style.line}>ab 90,-</div>
              <div className={style.line}>10,-</div>
              <div className={style.line}>ab 15,-</div>
            </div>
            <div className={style.priceColumn}>
              <div className={style.line}>Mittel</div>
              <div className={style.line}>55,-</div>
              <div className={style.line}>58,-</div>
              <div className={style.line}>&nbsp;</div>
              <div className={style.line}>15,-</div>
              <div className={style.line}>&nbsp;</div>
            </div>
            <div className={style.priceColumn}>
              <div className={style.line}>Lang</div>
              <div className={style.line}>65,-</div>
              <div className={style.line}>68,-</div>
              <div className={style.line}>&nbsp;</div>
              <div className={style.line}>25,-</div>
              <div className={style.line}>&nbsp;</div>
            </div>
          </div>
          <div className={style.info}>** Unsere Preise variieren je nach Aufwand, Materialverbrauch und Haarl&auml;nge.</div>
        </div>
        <div className={cx(style.gridElement, style.cosmetics)}>
          <div className={style.subtitle}>Styling und Kosmetik</div>
          <div className={style.priceTable}>
            <div className={style.articleColumn}>
              <div className={style.line}>Hochstecken nach Zeitaufwand</div>
              <div className={style.line}>Brautfrisur nach Aufwand</div>
              <div className={style.line}>Augenbrauen zupfen</div>
              <div className={style.line}>Augenbrauen f&auml;rben</div>
            </div>
            <div className={style.priceColumnStretch}>
              <div className={style.line}>ab 15 Minuten 20,-</div>
              <div className={style.line}>Nach Beratung und Aufwand</div>
              <div className={style.line}>15,-</div>
              <div className={style.line}>15,-</div>
            </div>
          </div>
        </div>
      </div>

      <div className={style.infoBottomContainer}>
        <div className={style.infoBottomLeft}>*</div>
        <div className={style.infoBottomLeft}>
          Alle Preise richten sich nach Haarl&auml;nge / Aufwand.
          <br />
          Alle Preise in € incl. der gesetzlichen MwSt.
          <br />
          Änderungen und Druckfehler vorbehalten.
          <br />
          Alle Preise inkl. Beratung.
          <br />
          Stand: 01.06.2026
        </div>
      </div>
    </div>
  );
}

const style = {
  container: css`
    padding: 10px;
  `,
  title: css`
    font-size: 24px;
  `,
  priceContainer: css`
    display: grid;
    column-gap: 20px;
    grid-template-columns: 1fr 1fr;
    @media (max-width: 1000px) {
      grid-template-columns: 1fr;
    }
  `,
  gridElement: css`
    width: 100%;
    padding: 10px 5px;
    box-sizing: border-box;
  `,
  women: css`
    order: 1;
    @media (max-width: 1000px) {
      order: 1;
    }
  `,
  men: css`
    order: 3;
    @media (max-width: 1000px) {
      order: 2;
    }
  `,
  children: css`
    order: 5;
    @media (max-width: 1000px) {
      order: 3;
    }
  `,
  coloration: css`
    order: 2;
    @media (max-width: 1000px) {
      order: 4;
    }
  `,
  cosmetics: css`
    order: 4;
    @media (max-width: 1000px) {
      order: 5;
    }
  `,
  subtitle: css`
    font-size: 22px;
  `,
  priceTable: css`
    display: flex;
    justify-content: space-between;
    @media (max-width: 520px) {
      font-size: 14px !important;
    }
    @media (max-width: 470px) {
      font-size: 12px !important;
    }
    @media (max-width: 440px) {
      font-size: 11px !important;
    }
    @media (max-width: 360px) {
      font-size: 10px !important;
    }
  `,
  articleColumn: css`
    flex-basis: 350px;
    flex: 5;
  `,
  priceColumn: css`
    flex-basis: 70px;
    flex: 1;
    text-align: center;
  `,
  priceColumnStretch: css`
    flex-basis: 350px;
    flex: 3;
    text-align: center;
    @media (max-width: 1200px) {
      flex: 4;
    }
    @media (max-width: 1020px) {
      flex: 5;
    }
    @media (max-width: 1000px) {
      flex: 3;
    }
    @media (max-width: 620px) {
      flex: 4;
    }
    @media (max-width: 530px) {
      flex: 5;
    }
  `,
  line: css`
    padding: 2px 2px;
    &:nth-child(2n) {
      background-color: #f3f3f3;
    }
  `,
  info: css`
    padding: 5px 5px 0 5px;
    font-size: 12px;
    @media (max-width: 470px) {
      font-size: 10px !important;
    }
  `,
  infoBottomContainer: css`
    padding: 10px 5px 0 5px;
    font-size: 12px;
    @media (max-width: 470px) {
      font-size: 10px !important;
    }
    display: flex;
  `,
  infoBottomLeft: css`
    font-size: 12px;
    padding-right: 4px;
    @media (max-width: 470px) {
      font-size: 10px !important;
    }
  `,
  infoBottomRight: css`
    font-size: 12px;
    @media (max-width: 470px) {
      font-size: 10px !important;
    }
  `,
};

export default Prices;
